import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import KpiDashboard from '../kpi/KpiDashboard';//eslint-disable-line import/no-named-as-default
import * as appHelper from '../../../helpers/appHelper';
import * as kpiHelper from '../../../helpers/kpiHelper';
import * as kpiConstants from '../../../constants/kpiConstants';
import * as dataHelper from '../../../helpers/dataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import {TweenLite, Elastic, Bounce, Expo} from 'gsap';
import gsap from 'gsap-react-plugin';


class OptionFeedback extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            feedback_options: props.feedback_options,
            scoreKpi: kpiHelper.getScoreKpi(this.props.bite),
            kpiDashboardParams: {
                responseReview: true,
                showTitle: false,
                showImmediateImpact: true,
                allowUpdates: false,

            },
            hideScoreKpi: true
        };
        this.show = this.show.bind(this);
        this.onOptionFeedbackRevealed = this.onOptionFeedbackRevealed.bind(this);
        this.setOptionClass = this.setOptionClass.bind(this);
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {

        if(this.state.feedback_options !== nextProps.feedback_options){
            this.setState({feedback_options: Object.assign([],nextProps.feedback_options)});
        }

    }

    show() {

        let feedbackPanel = this.refs[`${this.props.asset_id}_key-_feedback_options_panel-panel`];
        TweenLite.set(feedbackPanel, {height: "auto", opacity: 1});
        TweenLite.from(feedbackPanel, 0.2, {
            height: 0,
            opacity: 0,
            ease: Expo.easeInOut
        }).eventCallback("onComplete", this.onOptionFeedbackRevealed);
    }

    onOptionFeedbackRevealed() {
        if (appHelper.isDefined(this.props.onComplete)) {
            this.props.onComplete();
        }
    }

    setOptionClass(option) {
        if (this.props.responseData.scoring_type === objectConstants.SCORING_TYPE_ASSESSED && appHelper.isDefined(this.state.scoreKpi.kpi_id)) {
            let scoreKpiResults = appHelper.getArrayObjectByKey(option.kpis, "kpi_id", this.state.scoreKpi.kpi_id);
            if (appHelper.isDefined(scoreKpiResults)) {
                return kpiHelper.getKpiPointsIndicatorClass(scoreKpiResults.value,scoreKpiResults.kpi_id).class;
            } else {
                return option.result;
            }


        } else {
            return option.result;
        }
    }

    render() {
        return (
            <div className={`feedback-options-container`} ref={`${this.props.asset_id}_feedback_options_panel`}>
                {this.state.feedback_options.map(feedback_option =>
                    feedback_option.options.length > 0 && feedback_option.feedback.length > 0
                        ?
                        <div className="feedback-options-panel" key={`${feedback_option.option_id}_panel`}>
                            <ul className="feedback-options">
                                {feedback_option.options.map(option =>
                                    <li className={`feedback-option ${option.className} ${this.setOptionClass(option)}`}
                                        key={option.option_id}>
                                        <div dangerouslySetInnerHTML={{__html: option.option_text}}/>
                                    </li>
                                )}
                            </ul>
                            {
                                feedback_option.feedback.length > 0 && feedback_option.feedback !== "<p><br></p>"
                                    ? <div className="feedback-option-feedback"
                                           dangerouslySetInnerHTML={{__html: feedback_option.feedback}}/>
                                    : null
                            }
                        </div>
                        :
                        null
                )}


            </div>
        );
    }
}

OptionFeedback.propTypes = {
    feedback_options: PropTypes.array,
    asset_id: PropTypes.number.isRequired,
    bite: PropTypes.object,
    responseData: PropTypes.object,
    missedOptions: PropTypes.object,
    onComplete: PropTypes.func,
    actions: PropTypes.object
};

OptionFeedback.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        bite: appHelper.getBiteById(ownProps.responseData.bite_id)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, {}), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(OptionFeedback);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/OptionFeedback.js
 **/